import { ValidationSchema } from "_core/form";
import { HypervoltCableLength, HypervoltBaseColour } from "_core/types/charger";
import { ErrorMessages } from "_core/types";

export type FormValues = {
  cableLength: HypervoltCableLength | null;
  baseColour: HypervoltBaseColour | null;
};

export const HypervoltChargerCustomisation: ValidationSchema<FormValues> = {
  cableLength: ({ cableLength }) => {
    if (!cableLength) return ErrorMessages.SELECT_CABLE_LENGTH;
  },
  baseColour: ({ baseColour }) => {
    if (!baseColour) return ErrorMessages.SELECT_CHARGER_COLOUR;
  },
};
